import { withTranslation } from "react-i18next";
import Media from "react-media";
import system from "system-components";

import theme from "../../themes/policystat/theme";

import Tooltip from "pstat-design-system/Tooltip";
import { Text } from "pstat-design-system/text/paragraph";
import { DuoToneFontAwesomeIcon } from "pstat-anywhere/components/partials/icons";

const VersionSwitcher = props => {
  const currentPath = window.location.pathname;
  let params = window.location.search;
  let legacyPath = currentPath.replace(RegExp("^/v2/"), "/");
  if (legacyPath === "") {
    legacyPath = "/";
  } else if (legacyPath.startsWith(`/search`)) {
    legacyPath = "/policy_search/";
  }
  if (!legacyPath.endsWith("/")) {
    legacyPath += "/";
  }
  // path to legacy return view should be hard-coded "/v2/"
  // it is added to urls separate from PSA
  const switcherView = "/v2/to_legacy/";
  legacyPath =
    switcherView +
    "?next=" +
    encodeURIComponent(legacyPath) +
    encodeURIComponent(params);
  return (
    <Media query={{ minWidth: theme.breakpoints[1] }}>
      {isDesktop => (
        <SwitcherContainer px={isDesktop ? 3 : 8}>
          <SwitcherBorderContainer>
            <ToggleSwitchLink
              href={legacyPath}
              className="psa_to_legacy_switch"
            >
              <ToggleSwitchText>
                {props.t("partials.versionSwitcher.switchText")}
              </ToggleSwitchText>
              <ToggleSwitchCircle />
            </ToggleSwitchLink>
            <SwitcherText>
              {props.t("partials.versionSwitcher.label")}
            </SwitcherText>
            <DuoToneFontAwesomeIcon
              icon={["fad", "question-circle"]}
              size="sm"
              primaryColor={theme.colors.nav["100"]}
              secondaryColor={theme.colors.switch.help}
              data-tip
              data-for="version-switcher-tooltip"
              data-event="mouseover focus"
              data-event-off="mouseout blur"
            />
            <Tooltip name="version-switcher-tooltip">
              {props.t("partials.versionSwitcher.tooltip")}
            </Tooltip>
          </SwitcherBorderContainer>
        </SwitcherContainer>
      )}
    </Media>
  );
};

export default withTranslation()(VersionSwitcher);

const SwitcherContainer = system({
  height: "inherit",
  display: "flex",
  alignItems: "center",
  px: 3
});

const SwitcherBorderContainer = system({
  is: "span",
  display: "inline-flex",
  alignItems: "center",
  bg: "nav.0",
  border: 1,
  borderColor: "nav.10",
  borderRadius: "4px",
  color: "nav.100",
  px: 2,
  py: 1
});

const ToggleSwitchCircle = system({
  display: "inline-block",
  position: "absolute",
  top: 0,
  right: 0,
  mt: "1px",
  bg: "nav.100",
  width: "18px",
  height: "18px",
  borderRadius: "15px",
  boxShadow:
    "0 0 0 1px rgba(0, 0, 0, 0.9), 0 2px 0 -1px rgba(152, 162, 179, 0.3)"
});

const SwitcherText = system({
  is: Text,
  display: "inline-block",
  px: 2,
  fontSize: 1,
  color: "nav.100"
});

const ToggleSwitchLink = system({
  is: "a",
  display: "inline-flex",
  position: "relative",
  alignItems: "center",
  bg: "switch.background",
  borderRadius: "15px",
  height: "20px",
  width: "46px"
}).extend`
  text-decoration: none;
`;

const ToggleSwitchText = system({
  is: SwitcherText,
  fontSize: 0,
  pl: 2
});
